export const INT_RADIX = 10;
export const TRUE_STRING = 'true';
export const ZERO_STRING = '0';
export const TOPIC_LAYER_VISITS_DEFAULT = 0;
export const FOLLOW_UP_PARENT_ELEMENTS_CHECK = 10;
export const WHITESPACE_REGEX = /\s+/g;
export const SPACE_CHARACTER = ' ';
export const CSS_SELECTOR_SEPARATOR = ',';

export const PANEL_TABS = Object.freeze({
  NOTIFICATIONS: 'notifications',
  SETTINGS: 'settings'
});
